import axios from "axios"
import { exaUrl } from "../constants/constants"

let exaClient = axios.create({
  baseURL: exaUrl,
  responseType: "json"
})

export { exaClient }
